<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            :fields="fields"
            :items="surveys">
            <template v-slot:options>
                <div class="apprentice-group-table-actions">
                    <b-button
                        class="btn-add btn-new-group"
                        v-b-modal="'add-survey'"
                        variant="primary">
                        {{ $t('management.add_survey') }}
                    </b-button>

                    <design-2021-magagement-profile-choice-add-survey-modal-component
                        :las-main-groups-in="lasMainGroupsIn"
                        @survey-added="surveyAdded($event)">
                    </design-2021-magagement-profile-choice-add-survey-modal-component>
                </div>
            </template>

            <template v-slot:cell(actions)="row">
                <div class="survey-actions">
                    <b-button
                        class="btn-open btn-open-survey"
                        variant="primary-icon-only"
                        :href="routes.managementProfileChoiceSurveyShow(row.item.id)">
                    </b-button>
                    <b-button
                        class="btn-remove"
                        variant="danger-icon-only"
                        @click="removeSurvey(row.item)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
export default {
    name: 'design-2021-management-profile-choice-index-component',
    props: ['surveysIn', 'lasMainGroupsIn'],
    data() {
        return {
            surveys: this.surveysIn,
            fields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    methods: {
        surveyAdded(survey) {
            this.surveys.push(survey);
        },
        removeSurvey(survey) {
            this.alert.confirm().then((confirm) => {
                if (!confirm) {
                    return;
                }

                this.alert.saving();
                this.axios.delete(this.routes.managementProfileChoiceSurveyRemove(survey.id)).then(
                    (response) => {
                        this.surveys = this.surveys.filter((item) => item.id !== survey.id);
                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            });
        },
    },
};
</script>

<style scoped lang="scss">
.survey-actions {
    display: flex;

    .btn {
        font-size: 1.125rem;

        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'twenty-one');
        }
    }
}
</style>
